import { v4 as uuid } from 'uuid';
import { USER_DIALOG_ACTION_TYPES } from '../../constants/userDialog.constants';

export const showEditVehicleDialog = ({ vehicleId, requestId = uuid() }) => ({
  type: USER_DIALOG_ACTION_TYPES.SHOW_EDIT_VEHICLE_DIALOG,
  payload: { vehicleId, requestId },
});

export const hideEditVehicleDialog = (requestId) => ({
  type: USER_DIALOG_ACTION_TYPES.HIDE_EDIT_VEHICLE_DIALOG,
  payload: { requestId },
});

export const vehicleDialogUpdated = (vehicle, requestId) => ({
  type: USER_DIALOG_ACTION_TYPES.VEHICLE_DIALOG_UPDATED,
  payload: { vehicle, requestId },
});
